const ABANDON_ERRORS = {
    CLIENT_101: "Transaction abandonnée",
    CLIENT_103: "Délai d'attente dépassé",
    CLIENT_105: "Paiement non finalisé",
    CLIENT_604: "L'utilisateur a fermé la fenêtre"
};
  
export function isPayzenPaymentAbandoned(code) {
    if (ABANDON_ERRORS[code]) {
      return true;
    }
    return false;
  }
  
  